import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { RuntimeConfigService } from '../_shared/services/services-index';

@Component({
    styleUrls: ['./errors.component.scss'],
    templateUrl: './errors.component.html',
    standalone: false
})
export class ErrorsComponent implements OnInit {
    errorMessage: string;

    constructor(private routeLocation: Location, private router: Router, private runtimeService: RuntimeConfigService) {}

    ngOnInit() {
        //get error message from runtime service
        this.errorMessage = this.runtimeService.config.clientErrorScreenMessage;
    }

    goBack() {
        // this.router.navigateByUrl('/');
        this.routeLocation.back();
    }

    goHome() {
        this.router.navigateByUrl('/');
    }
}
